export default "__VITE_ASSET__DEKkXQCz__"